import { Component, HostListener, Input, OnInit } from '@angular/core';
import { AppConstants } from 'src/app/core/constants';

@Component({
  selector: 'app-no-cost-emi-bank-offer',
  templateUrl: './no-cost-emi-bank-offer.component.html',
  styleUrls: ['./no-cost-emi-bank-offer.component.scss',],
})
export class NoCostEmiBankOfferComponent {

  @Input() isLargeScreen: boolean = true;
  
  @HostListener('window:resize', ['$event',])
  onResize(_event: Event) {
    this.isLargeScreen =  window.innerWidth > AppConstants.SMALL_SCREEN;
  }
}
